<split-steps #steps>
  <split-step [passo]="0">
    <!-- <span  class="gray-text pt-0" >Adicionar receita:</span> -->

    <form [formGroup]="form">
      <div class="grid p-fluid">

        <div class="col-6">
          <span class="p-float-label">
            <input pInputText id="nomeReceita" formControlName="name" />
            <label
              htmlFor="nomeReceita"
              class="pl-1 h-1rem flex align-items-center"
              for="float-label"
            >
              Nome do gasto
            </label>
          </span>
        </div>
      </div>
    </form>
  </split-step>

  <ng-template #customNextButton>
    <div class="col-12 mt-7 px-0 text-right">
      <p-button (onClick)="saveForm()" class="ml-4" label="Salvar"></p-button>
    </div>
  </ng-template>
  <ng-template #customPreviousButton>
    <div class="col-12 mt-7 px-0">
      <p-button
        (onClick)="closeForm()"
        class=""
        severity="secondary"
        [outlined]="true"
        label="Cancelar"
      ></p-button>
    </div>
  </ng-template>
</split-steps>
